/*
  Partner Club page (template page.partner-club.json,
  sections pc-*). Ported from the Partner Hub prototype v66.

  The words, photos, sports, team and quiz questions are all edited in the theme editor.
  Each pc-* section hands its share to this script as JSON (<script data-kpc="...">):
  hero (sports), proof (club stories and gallery), team, sorted, how, enquire, and
  quiz-public / quiz-club / quiz-assoc (the enquiry questions). What stays in code: the
  supplier list, the regions, the priority codes and the supplier rules, because rep
  links and the enquiry email depend on them never changing by accident.

  One IIFE, run once per page however many sections include it: Shella loads jQuery as
  a global `$`, so nothing here may leak a global.

  Personalised links (made in Coach, KPI's CRM, from a club's record; the Shopify rep link builder was retired 22 Oct 2026)
  carry the club, sport, manager, type, crest, supplier and priorities as one token after
  a hash: /pages/partner-club#k=<base64url JSON>. See readLink() below; it keeps the
  details out of analytics.
*/
(function () {
  "use strict";
  var HTML = document.documentElement;
  if (HTML.hasAttribute("data-kpc-ready") || !document.querySelector(".kpc")) return;
  HTML.setAttribute("data-kpc-ready", "");

  var $ = function (s) { return document.querySelector(s); };
  var $$ = function (s) { return document.querySelectorAll(s); };
  var byId = function (id) { return document.getElementById(id); };
  var each = function (list, fn) { Array.prototype.forEach.call(list || [], fn); };
  var esc = function (s) { return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]; }); };
  /* "[club]", "[manager]"... in a theme editor text become the values given */
  var fill = function (t, map) { return String(t || "").replace(/\[(\w+)\]/g, function (m, k) { return map[k] != null ? map[k] : m; }); };
  var setText = function (id, v) { var e = byId(id); if (e) e.textContent = v; return e; };
  var setHTML = function (id, v) { var e = byId(id); if (e) e.innerHTML = v; return e; };
  var hide = function (id, on) { var e = byId(id); if (e) e.hidden = !!on; return e; };
  function toast(m) { var t = document.createElement("div"); t.className = "toast"; t.setAttribute("role", "status"); t.textContent = m; ($(".kpc") || document.body).appendChild(t); setTimeout(function () { t.remove(); }, 2600); }
  /* A logo arrives on a public URL, so it only ever renders from KPI's own Shopify
     files (the crest upload lands in .../4647/uploads/), and never with characters
     that could break out of the style attribute. Any other address is ignored. */
  function safeLogo(u) {
    u = String(u || "").trim();
    if (!u || /["'()<>\\\s]/.test(u)) return "";
    if (/^https:\/\/cdn\.shopify\.com\/s\/files\/1\/0413\/1543\/4647\//.test(u)) return u;
    return "";
  }
  function bg(url, pos) { return url ? "background-image:url('" + esc(url) + "')" + (pos ? ";background-position:" + esc(pos) : "") : ""; }

  /* Current supplier: one list shared with the rep link builder, from snippets/pc-suppliers
     (data-kpc="suppliers"; see that file for the shape). The option value is the slug,
     never the label, and the personalised link carries it as `inc`. The supplier rules
     below and Coach both match on the slugs, so they never change once live. */
  var SUP = { list: [], by: {}, tail: [] };
  function loadSuppliers() {
    var s = CFG.suppliers || {}, c = COACH();
    SUP = { list: (s.suppliers || []).filter(function (x) { return x && x.slug; }), by: s.bySport || {}, tail: s.tail || [] };
    /* Coach's published list replaces the theme's, keeping the theme's own tail entries */
    if (c && c.suppliers && c.suppliers.length) {
      var tail = SUP.tail;
      SUP.list = c.suppliers.filter(function (x) { return x && x.slug && tail.indexOf(x.slug) < 0; })
        .concat(SUP.list.filter(function (x) { return tail.indexOf(x.slug) >= 0; }));
      SUP.by = c.bySport || {};
    }
  }
  /* Coach's published document (#1066), from snippets/pc-suppliers: null until Coach has
     published, and then the theme's own lists apply unchanged. */
  function COACH() { var c = CFG.coach; return c && typeof c === "object" && c.version ? c : null; }
  /* A club story, gallery photo or association with a Coach club ID shows only while that
     club is a current partner in Coach; one without an ID always shows. */
  function stillPartner(x) {
    var c = COACH();
    if (!c || !c.partners || !x || !x.coach) return true;
    return c.partners.indexOf(String(x.coach).trim()) >= 0;
  }
  var supplierName = function (slug) { var s = SUP.list.filter(function (x) { return x.slug === slug; })[0]; return s ? s.label : ""; };
  /* slugs to offer for a sport (a code like "football" or a name like "Football"): that
     sport's own order if it has one, otherwise every supplier A to Z; then the tail */
  function supplierSlugs(sport) {
    var key = String(sport || "").toLowerCase().replace(/[^a-z0-9]+/g, "-"), tail = SUP.tail;
    var main = SUP.by[key] || SUP.list.filter(function (x) { return tail.indexOf(x.slug) < 0; })
      .sort(function (a, b) { return a.label.localeCompare(b.label, "en", { sensitivity: "base" }); })
      .map(function (x) { return x.slug; });
    return main.concat(tail).filter(function (slug, i, a) { return supplierName(slug) && a.indexOf(slug) === i; });
  }
  function supplierOptions(sport, keep) {
    return '<option value="">Choose…</option>' + supplierSlugs(sport).map(function (slug) {
      return '<option value="' + esc(slug) + '"' + (slug === keep ? " selected" : "") + ">" + esc(supplierName(slug)) + "</option>";
    }).join("");
  }

  /* A personalised link already knows the club, but the store's contact form still
     needs someone to reply to. A quiz without an email question (f-email) gets this step. */
  var CONTACT_STEP = [
    { isStep: true, g: "Who should we reply to?" },
    { t: "text", id: "f-name", l: "Your name", ac: "name" },
    { t: "text", id: "f-email", l: "Email", it: "email", ac: "email" },
    { t: "text", id: "f-phone", l: "Phone", it: "tel", ac: "tel", full: true }
  ];
  var REGIONS = {
    "Queensland": ["Brisbane North", "Brisbane South", "Brisbane West", "Moreton Bay", "Ipswich", "Logan", "Redlands", "Gold Coast", "Sunshine Coast", "Toowoomba & Darling Downs", "South Burnett", "Wide Bay (Bundaberg, Hervey Bay, Maryborough)", "Gladstone", "Rockhampton & Capricorn Coast", "Mackay & Whitsunday", "Townsville", "Cairns & Far North", "Mount Isa & North West", "Central West & Outback"],
    "New South Wales": ["Sydney North & Northern Beaches", "Sydney East & Inner City", "Sydney Inner West", "Sydney West & Hills", "Sydney South West", "Sydney South & Sutherland Shire", "Central Coast", "Newcastle & Hunter", "Illawarra & South Coast", "Northern Rivers", "Mid North Coast", "New England & North West", "Central West & Orana", "Riverina & Murray", "Southern Tablelands & Snowy", "Far West"],
    "Australian Capital Territory": ["Canberra North & Gungahlin", "Canberra South & Tuggeranong", "Belconnen", "Woden & Weston Creek", "Queanbeyan & surrounds"],
    "Victoria": ["Melbourne North", "Melbourne East", "Melbourne South East", "Melbourne West", "Melbourne Inner", "Mornington Peninsula", "Geelong & Surf Coast", "Ballarat & Central Highlands", "Bendigo & Loddon", "Gippsland", "Hume & North East", "Western Victoria & Wimmera", "Mallee & Mildura"],
    "Tasmania": ["Hobart & South", "Launceston & North", "North West Coast", "East Coast"],
    "South Australia": ["Adelaide North", "Adelaide South", "Adelaide East & Hills", "Adelaide West", "Barossa & Gawler", "Fleurieu & Kangaroo Island", "Limestone Coast", "Riverland & Murraylands", "Yorke & Mid North", "Eyre Peninsula & Far North"],
    "Western Australia": ["Perth North", "Perth South", "Perth East & Hills", "Peel & Mandurah", "South West (Bunbury, Busselton)", "Great Southern", "Wheatbelt", "Goldfields & Esperance", "Mid West & Gascoyne", "Pilbara", "Kimberley"],
    "Northern Territory": ["Darwin & Palmerston", "Katherine & Big Rivers", "Alice Springs & Central Australia", "East Arnhem & regional NT"],
    "Outside Australia": ["New Zealand", "Pacific Islands", "Other"]
  };
  /* the "Sport" question's options when the quiz block leaves them blank */
  var FORM_SPORTS = ["Football", "Netball", "Hockey", "Athletics", "Cricket", "Futsal", "Swimming", "Volleyball", "Squash", "Pickleball", "Basketball", "AFL", "Rugby", "E-sport", "Softball", "Baseball", "Other"];

  /* ---- Content from the sections ---- */
  var CFG = {}, SPORTS = {}, SPORT_KEYS = [], AMS = [], FORMS = {}, TXT = {};
  /* quiz block -> form field. Answer types are the "Answer type" choices on a Question block. */
  function toField(q, i) {
    if (!q.kind) return { isStep: true, g: q.g || "", small: q.small || "" };
    var f = { id: String(q.id || "").replace(/[^A-Za-z0-9_-]/g, "-") || "f-q" + i, l: q.l || "", ph: q.ph || "", full: !!q.full, max: Number(q.max) || 0, o: q.o || [] };
    f.t = { email: "text", phone: "text", dropdown: "select", chips: "chips", long_text: "area", state_region: "state", sport: "sport", supplier: "supplier", team: "team" }[q.kind] || "text";
    if (q.kind === "email") { f.it = "email"; f.ac = "email"; }
    if (q.kind === "phone") { f.it = "tel"; f.ac = "tel"; }
    if (q.kind === "long_text") f.rows = 6;
    if (f.id === "f-name") f.ac = "name";
    return f;
  }
  function load() {
    CFG = {};
    each($$("script[data-kpc]"), function (el) {
      try { CFG[el.getAttribute("data-kpc")] = JSON.parse(el.textContent); }
      catch (err) { if (window.console && console.error) console.error("Partner Club: couldn't read the " + el.getAttribute("data-kpc") + " section settings", err); }
    });
    loadSuppliers();
    var hero = CFG.hero || {}, proof = CFG.proof || {};
    SPORTS = {}; SPORT_KEYS = [];
    (hero.sports || []).forEach(function (s) {
      if (!s.key || SPORTS[s.key]) return;
      var mine = function (x) { return x.sport === s.key; };
      SPORT_KEYS.push(s.key);
      SPORTS[s.key] = Object.assign({}, s, {
        stories: (proof.stories || []).filter(function (x) { return mine(x) && stillPartner(x); }),
        gallery: (proof.photos || []).filter(function (x) { return mine(x) && !x.more && stillPartner(x); }),
        kits: (proof.photos || []).filter(function (x) { return mine(x) && x.more && stillPartner(x); })
      });
    });
    AMS = ((CFG.team || {}).ams || []).filter(function (a) { return a.id; });
    TXT = CFG.enquire || {};
    FORMS = {};
    ["public", "club", "assoc"].forEach(function (m) {
      var fields = ((CFG["quiz-" + m] || {}).fields || []).map(toField);
      if (!fields.some(function (f) { return f.id === "f-email"; })) fields = fields.concat(CONTACT_STEP);
      var t = TXT[m] || {};
      FORMS[m] = { eyebrow: t.eyebrow || "", h2: t.h2 || "", intro: t.intro || "", fields: fields };
    });
  }
  var findAm = function (id) { return AMS.filter(function (a) { return a.id === id; })[0]; };

  var S = { sport: "", club: "", am: "", type: "club", logo: "", inc: "", pri: [] };   /* type: club | assoc */
  var MODE = function () { return S.type === "assoc" ? "assoc" : (S.club ? "club" : "public"); };
  /* PREF = who they asked to talk to: a team code from "Talk to …" or the quiz's team
     question, "none" for an explicit "No preference", "" for not asked (falls back to the
     manager on their link). */
  var PREF = "";
  var askedAm = function () { return PREF === "none" ? null : findAm(PREF || S.am); };

  function render() {
    var sp = SPORTS[S.sport], hero = CFG.hero || {}, proof = CFG.proof || {}, sorted = CFG.sorted || {}, how = CFG.how || {};
    var am = findAm(S.am);
    var isAssoc = MODE() === "assoc", personal = MODE() !== "public", who = S.club || (isAssoc ? "your association" : "your club");
    var mgr = am ? am.name : (hero.managerFallback || "your own KPI account manager");
    if (sp) {
      var h1 = byId("h1");
      if (h1) {
        h1.innerHTML = (personal ? esc(fill(hero.personalH1, { club: who })) : esc(String(sp.h1 || "").replace(/\.$/, ""))) + '<span class="dot">.</span>';
        h1.classList.toggle("long", personal);
      }
      setText("sub", personal && sp.subPersonal ? fill(sp.subPersonal, { manager: mgr, club: who }) : sp.sub);
      var photo = byId("photo"); if (photo) { photo.style.backgroundImage = sp.photo ? "url('" + sp.photo + "')" : ""; photo.style.backgroundPosition = sp.photoPos || ""; }
      setText("photoCredit", sp.credit || "");
      each($$("[data-sport]"), function (b) {
        b.setAttribute("aria-pressed", String(b.getAttribute("data-sport") === S.sport));
        b.onclick = function () { if (SPORTS[b.getAttribute("data-sport")]) { S.sport = b.getAttribute("data-sport"); render(); } };
      });
      var band = byId("band");
      if (band) { band.hidden = !sp.band; band.style.backgroundImage = sp.band ? "url('" + sp.band + "')" : ""; band.style.backgroundPosition = sp.bandPos || ""; setText("bandCredit", sp.bandCredit || ""); }
      var hasQ = sp.stories.some(function (s) { return s.q; });
      setText("proofH", fill(hasQ ? proof.headingQuotes : proof.headingPlain, { sport: sp.name }));
      var st = byId("stories");
      if (st) {
        st.style.setProperty("--scols", Math.max(3, sp.stories.length));   /* two quoted clubs shouldn't stretch across the row */
        st.innerHTML = sp.stories.map(function (s) {
          return '<article class="story"><div class="ph" style="' + bg(s.img, s.pos) + '" role="img" aria-label="' + esc(s.club) + '"></div><div class="body"><span class="credit">' + esc(s.club) + " · " + esc(sp.name) + "</span>" +
            (s.q ? "<blockquote>" + esc(s.q) + '</blockquote><span class="who">' + esc(s.who) + "</span>" : '<h3 class="clubname">' + esc(s.club) + "</h3>" + (s.partner && proof.partnerLabel ? '<span class="who">' + esc(proof.partnerLabel) + "</span>" : "")) + "</div></article>";
        }).join("");
      }
      var fig = function (g) { return '<figure style="' + bg(g.img, g.pos) + '"><figcaption>' + esc(g.club) + "</figcaption></figure>"; };
      var kits = sp.kits, n = sp.gallery.length, kg = byId("kitGrid"), gg = byId("galleryGrid");
      hide("moreKits", !kits.length); setText("moreKits", proof.more || "");
      if (kg) {
        kg.hidden = true;
        kg.style.setProperty("--cols", kits.length < 3 ? 3 : (kits.length % 4 === 0 ? 4 : (kits.length % 3 === 0 ? 3 : 4)));
        kg.innerHTML = kits.map(fig).join("");
      }
      hide("gallery", !n && !kits.length);
      hide("galleryH", !n); setText("galleryH", fill(proof.galleryHeading, { sport: String(sp.name || "").toLowerCase() }));
      if (gg) {
        gg.style.setProperty("--cols", n < 3 ? 3 : (n % 5 === 0 && n > 5 ? 5 : (n % 4 === 0 ? 4 : (n % 3 === 0 ? 3 : 4))));
        gg.innerHTML = sp.gallery.map(fig).join("");
      }
    }
    var pe = byId("prepared");
    if (pe) {
      if (S.club || am) {
        var av = am && am.photo ? '<span class="av" style="' + bg(am.photo) + '"></span>' : '<span class="av">' + esc(am ? am.name.charAt(0) : "K") + "</span>";
        var crest = S.logo ? '<span class="crest" style="' + bg(S.logo) + '" role="img" aria-label="' + esc(S.club || "Club") + ' crest"></span>' : "";
        pe.innerHTML = '<div class="prepared">' + crest + av + "<div><b>" + esc(fill(hero.preparedTitle || "Prepared for [club]", { club: S.club || "your club" })) + "</b><span>" +
          esc(am ? fill(hero.preparedBy || "by [manager], your KPI [role]", { manager: am.name, role: am.role }) : (hero.preparedTeam || "")) + "</span></div></div>";
      } else pe.innerHTML = "";
    }
    each($$("#ams .am"), function (card) {
      var id = card.getAttribute("data-am");
      card.classList.toggle("match", !!am && id === am.id);
      card.classList.toggle("dim", !!am && id !== am.id);
    });
    /* On a personalised link the quiz stays last (the spec pins #enquire to the end, and
       the promoted sections should be what they read first), so the hero offers a
       straight jump to it instead of the public page's two buttons. */
    setText("heroCta", personal ? hero.ctaPersonal : (isAssoc ? hero.ctaAssoc : hero.ctaClub));
    hide("previewLink", personal);
    setText("closerCta", isAssoc ? (sorted.ctaAssoc || sorted.ctaClub) : sorted.ctaClub);
    hide("associations", MODE() === "club");
    /* a club that was sent a link already knows its sport, and the page speaks to it by name */
    hide("sportPick", personal);
    /* supplier-aware lead copy: replaces the opening line of the promoted sections */
    setHTML("sortedIntro", leadFor("sorted") || "<p>" + esc(personal ? fill(sorted.introPersonal, { club: who }) : sorted.intro) + "</p>");
    setHTML("howIntro", leadFor("how") || "<p>" + esc(how.intro) + "</p>");
    var wins = CFG.wins || {};
    setHTML("winsIntro", leadFor("wins") || (wins.intro ? "<p>" + esc(wins.intro) + "</p>" : ""));
    var proofLead = leadFor("proof"); setHTML("proofIntro", proofLead); hide("proofIntro", !proofLead);
    renderForm();
    each($$("[data-talk]"), function (b) { b.onclick = function () { PREF = b.getAttribute("data-talk"); renderTo(); }; });
    renderTo();
  }

  /* Builds the enquiry from the quiz section for the current audience. data-q carries the
     question text so the submitted email reads as question: answer. */
  function field(f) {
    var cls = f.full ? ' class="full"' : "";
    if (f.t === "chips") return '<div class="full">' + (f.l ? '<span class="lab" style="margin-bottom:6px">' + esc(f.l) + "</span>" : "") + '<div class="chips" id="' + f.id + '" data-max="' + (f.max || 0) + '" data-q="' + esc(f.l || f.qd || "") + '">' + f.o.map(function (o) { return '<button type="button" class="chip" aria-pressed="false">' + esc(o) + "</button>"; }).join("") + "</div></div>";
    if (f.t === "state") return '<label>State or territory<select id="f-state" data-q="State or territory"><option value="">Choose…</option>' + Object.keys(REGIONS).map(function (x) { return "<option>" + esc(x) + "</option>"; }).join("") + "</select></label>" +
      '<label>Region<select id="f-region" data-q="Region" disabled><option value="">Choose your state first</option></select></label>';
    if (f.t === "sport") {
      var mine = SPORTS[S.sport] ? SPORTS[S.sport].name : "";
      return "<label" + cls + ">" + esc(f.l) + '<select id="' + f.id + '" data-sport-q data-q="' + esc(f.l) + '">' + (f.o.length ? f.o : FORM_SPORTS).map(function (n) { return "<option" + (n === mine ? " selected" : "") + ">" + esc(n) + "</option>"; }).join("") + "</select></label>";
    }
    if (f.t === "select") return "<label" + cls + ">" + esc(f.l) + '<select id="' + f.id + '" data-q="' + esc(f.l) + '">' + f.o.map(function (o) { return "<option>" + esc(o) + "</option>"; }).join("") + "</select></label>";
    /* supplier dropdown (value = slug) plus the name box "Other" reveals, in one grid cell */
    if (f.t === "supplier") return '<div class="supp">' +
      "<label>" + esc(f.l) + '<select id="' + f.id + '" data-q="' + esc(f.l) + '">' + supplierOptions(SPORTS[S.sport] ? SPORTS[S.sport].name : "") + "</select></label>" +
      '<label class="supp-other" hidden>Supplier name<input id="' + f.id + '-other" data-q="' + esc(f.l) + ' (other)" placeholder="Who do you use now?"></label></div>';
    /* who they'd like to talk to: the people in "Partner: team", preselected from "Talk to …" or their link */
    if (f.t === "team") {
      if (!AMS.length) return "";
      var mineAm = askedAm();
      return "<label" + cls + ">" + esc(f.l) + '<select id="' + f.id + '" data-team data-q="' + esc(f.l) + '"><option value="">No preference</option>' + AMS.map(function (a) { return '<option value="' + esc(a.id) + '"' + (mineAm && mineAm.id === a.id ? " selected" : "") + ">" + esc(a.name) + (a.role ? " · " + esc(a.role) : "") + "</option>"; }).join("") + "</select></label>";
    }
    if (f.t === "area") return "<label" + cls + ">" + esc(f.l) + '<textarea id="' + f.id + '" data-q="' + esc(f.l) + '" rows="' + (f.rows || 5) + '"' + (f.ph ? ' placeholder="' + esc(f.ph) + '"' : "") + "></textarea></label>";
    /* name, email and phone post as the contact form's own fields */
    var nm = { "f-name": "contact[name]", "f-email": "contact[email]", "f-phone": "contact[phone]" }[f.id];
    return "<label" + cls + ">" + esc(f.l) + '<input id="' + f.id + '" data-q="' + esc(f.l) + '"' + (nm ? ' name="' + nm + '"' : "") + (f.it ? ' type="' + f.it + '"' : "") + (f.ac ? ' autocomplete="' + f.ac + '"' : "") + (f.ph ? ' placeholder="' + esc(f.ph) + '"' : "") + "></label>";
  }
  var STEPS = [], AT = 0;
  function showStep(n) {
    AT = Math.max(0, Math.min(STEPS.length - 1, n));
    each($$("#enq .step"), function (el, i) { el.hidden = i !== AT; });
    each($$("#enq .steps-dots i"), function (el, i) { el.classList.toggle("on", i <= AT); });
    setText("stepNum", fill(TXT.stepOf || "Step [n] of [total]", { n: AT + 1, total: STEPS.length }));
    hide("stepBack", AT === 0);
    hide("stepNext", AT === STEPS.length - 1);
    hide("stepSend", AT !== STEPS.length - 1);
  }
  function renderForm() {
    var enq = byId("enq");
    if (!enq) return;   /* already sent (or no enquiry section): nothing to build */
    var cfg = FORMS[MODE()], personal = MODE() !== "public";
    var who = S.club || (MODE() === "assoc" ? "your association" : "your club");
    setText("enqEyebrow", cfg.eyebrow);
    setHTML("enqH2", esc(personal ? cfg.h2.replace(/your (club|association)\b/, who) : cfg.h2) + '<span class="dot">.</span>');
    setText("enqIntro", personal ? cfg.intro.replace("your club", who).replace("your association", who) : cfg.intro);

    /* one group per step, so nobody ever sees the whole list at once.
       on a personalised link the questions name the club, not "your club".
       Unlabelled tick boxes take their step title as the question in the email. */
    var say = function (t) { return personal && t ? String(t).replace(/your (club|association)\b/g, who) : t; };
    STEPS = []; var cur = null;
    cfg.fields.forEach(function (f0) {
      var f = Object.assign({}, f0);
      ["g", "l", "ph"].forEach(function (k) { if (f[k]) f[k] = say(f[k]); });
      if (f.isStep) { cur = { title: f.g, small: f.small, fields: [] }; STEPS.push(cur); return; }
      if (!cur) { cur = { title: "", fields: [] }; STEPS.push(cur); }
      if (f.t === "chips" && !f.l) f.qd = cur.title;
      cur.fields.push(f);
    });
    STEPS = STEPS.filter(function (st) { return st.fields.length; });
    var nav = '<div class="stepnav"><span class="of"><span id="stepNum"></span></span><span class="steps-dots">' + STEPS.map(function (_, i) { return '<i class="' + (i ? "" : "on") + '"></i>'; }).join("") + '</span><span class="right"><button class="kbtn back" type="button" id="stepBack" hidden>' + esc(TXT.back || "Back") + '</button><button class="kbtn" type="button" id="stepNext">' + esc(TXT.next || "Next") + '</button><button class="kbtn" type="submit" id="stepSend" hidden>' + esc(TXT.send || "Send") + "</button></span></div>";
    enq.innerHTML = STEPS.map(function (st, i) {
      return '<fieldset class="step" data-step="' + i + '" ' + (i ? "hidden" : "") + '><div class="grp">' + esc(st.title) + (st.small ? "<small>" + esc(st.small) + "</small>" : "") + "</div>" + st.fields.map(field).join("") + "</fieldset>";
    }).join("") + nav + '<div class="full" style="margin-top:8px"><span id="toWho" style="font-size:14px;color:var(--mute)"></span></div>';
    byId("stepNext").onclick = function () { showStep(AT + 1); enq.scrollIntoView({ block: "nearest", behavior: "smooth" }); };
    byId("stepBack").onclick = function () { showStep(AT - 1); enq.scrollIntoView({ block: "nearest", behavior: "smooth" }); };
    showStep(0);

    if (S.club && byId("f-club")) byId("f-club").value = S.club;
    var st = byId("f-state");
    if (st) st.onchange = function () {
      var v = st.value, r = byId("f-region");
      r.disabled = !v; r.innerHTML = v ? '<option value="">Choose…</option>' + REGIONS[v].map(function (x) { return "<option>" + esc(x) + "</option>"; }).join("") : '<option value="">Choose your state first</option>';
    };
    /* the supplier list follows the sport chosen earlier in the quiz (Build Spec stage 1) */
    var sportQ = enq.querySelector("select[data-sport-q]");
    each(enq.querySelectorAll(".supp"), function (box) {
      var sup = box.querySelector("select"), wrap = box.querySelector(".supp-other"), other = wrap.querySelector("input");
      sup.onchange = function () {
        wrap.hidden = sup.value !== "other";
        if (!wrap.hidden) other.focus(); else other.value = "";
      };
      if (sportQ) {
        sup.innerHTML = supplierOptions(sportQ.value, sup.value);
        sportQ.addEventListener("change", function () {
          var was = sup.value;
          sup.innerHTML = supplierOptions(sportQ.value, was);
          if (sup.value !== was) { wrap.hidden = true; other.value = ""; }
        });
      }
    });
    each(enq.querySelectorAll("select[data-team]"), function (sel) {
      sel.onchange = function () { PREF = sel.value || "none"; renderTo(); };
    });
    each(enq.querySelectorAll(".chips"), function (box) {
      var max = Number(box.getAttribute("data-max") || 0);
      each(box.querySelectorAll(".chip"), function (b) {
        b.onclick = function () {
          var on = b.getAttribute("aria-pressed") === "true";
          if (!on && max && box.querySelectorAll('[aria-pressed="true"]').length >= max) { toast("Pick up to " + max); return; }
          b.setAttribute("aria-pressed", String(!on));
          if (!on) b.setAttribute("data-at", String(Date.now())); else b.removeAttribute("data-at");   /* the order picked, for the thank-you */
        };
      });
    });
  }
  /* ---- Supplier-aware content and section reordering (Partner Page Build Spec, stages 3-4) ----
     Copy rule for every lead: never name, describe or imply a competitor. The page
     leads with KPI's own strengths; it never refers to the incumbent. */
  /* inc slug -> sections to promote, in rank order (Build Spec stage 3). Each promoted
     section opens with that supplier's lead copy, edited in the theme editor on the section
     itself ("When their supplier is …"). Every other slug, an unknown one, none, or a
     supplier switched off in "Partner: hero" (Supplier content) falls to _default:
     today's page. */
  var INCUMBENT = {
    veto: { promote: ["how", "sorted"] },
    ev2: { promote: ["proof", "wins"] },
    struddys: { promote: ["wins", "how"] },
    game: { promote: ["wins", "how"] },
    kappa: { promote: ["sorted", "wins"] },
    uhlsport: { promote: ["sorted", "how"] },
    _default: { promote: [] }
  };
  var variant = function () {
    var on = (CFG.hero || {}).variants || {};
    return INCUMBENT[S.inc] && S.inc !== "_default" && on[S.inc] !== false ? INCUMBENT[S.inc] : INCUMBENT._default;
  };
  var leadFor = function (sec) { return variant() === INCUMBENT._default ? "" : (((CFG[sec] || {}).leads || {})[S.inc] || ""); };
  /* pri codes (what the account manager says the club cares about, up to 3) -> sections
     to promote. Same codes as PRIORITY_CODES in Coach (src/modules/striker/lib/partner-page.ts). */
  var PRIORITIES = {
    shop: ["how", "wins"], admin: ["sorted", "how"], money: ["wins", "sorted"],
    design: ["sorted", "proof"], service: ["team", "proof"], committee: ["committee", "faq"]
  };
  var PRIORITY_NAMES = { shop: "Club shop and online ordering", admin: "Volunteer time and admin", money: "Money back to the club", design: "Design and how the kit looks", service: "Service and a person who turns up", committee: "Taking it to a committee" };
  /* Reorder once at load with the CSS `order` property on the theme's section column,
     never by moving section nodes (in-page anchors like #enquire and #faq rely on the DOM).
     Public page: untouched, so the order set in the theme editor is what shows.
     Personalised link: the rep bar, hero and fact bar stay on top, then the enquiry (the
     club was sent the link to answer it, so it isn't left at the bottom), then the
     promoted sections in rank order (#sorted always above #wins), then everything else in
     its editor order. The sign-off bar travels to the very end, and the divider above the
     enquiry is dropped while it sits under the fact bar. */
  var wrapOf = function (el) { return el.closest(".shopify-section") || el; };
  function applyOrder() {
    var ranked = [];
    S.pri.forEach(function (code) { PRIORITIES[code].forEach(function (id) { if (ranked.indexOf(id) < 0) ranked.push(id); }); });
    variant().promote.forEach(function (id) { if (ranked.indexOf(id) < 0) ranked.push(id); });
    ranked = ranked.filter(function (id) { return id !== "enquire" && byId(id); });
    var si = ranked.indexOf("sorted"), wi = ranked.indexOf("wins");
    if (wi > -1 && (si < 0 || si > wi)) { if (si > -1) ranked.splice(si, 1); ranked.splice(ranked.indexOf("wins"), 0, "sorted"); }
    var first = $(".kpc"), enq = byId("enquire"), quizUp = MODE() !== "public" && !!enq;
    if ((!ranked.length && !quizUp) || !first) return;
    var host = wrapOf(first).parentElement, kids = Array.prototype.slice.call(host.children);
    var firstAt = kids.indexOf(wrapOf(first));
    host.style.display = "flex"; host.style.flexDirection = "column";
    kids.forEach(function (k, i) {
      var pin = k.querySelector("[data-kpc-pin]");
      k.style.order = String(i < firstAt ? i - 30000 : (pin ? i - 20000 : i + 1));
    });
    ranked.forEach(function (id, i) { wrapOf(byId(id)).style.order = String(i - ranked.length); });
    if (quizUp) {
      wrapOf(enq).style.order = String(-1000);
      hide("formDiv", true);
      var off = enq.parentNode.querySelector(".signoff");
      if (off && !byId("kpcTail")) {
        var tail = document.createElement("div");
        tail.className = "kpc"; tail.id = "kpcTail"; tail.style.order = "99999";
        tail.appendChild(off); host.appendChild(tail);
      }
    }
  }
  /* Floating "start" button: shows once the hero has scrolled away, hides again while the
     enquiry is on screen or once it has been sent. Label = the hero's button text. */
  var stickyObs = null;
  function sticky() {
    var hero = $(".kpc .hero"), enqSec = byId("enquire"), hcfg = CFG.hero || {};
    var btn = byId("kpcSticky");
    if (!hero || !enqSec || hcfg.sticky === false || !window.IntersectionObserver) { if (btn) btn.hidden = true; return; }
    if (!btn) {
      btn = document.createElement("a");
      btn.id = "kpcSticky"; btn.className = "kbtn kpc-sticky"; btn.href = "#enquire"; btn.hidden = true;
      hero.parentNode.appendChild(btn);
    }
    var isAssoc = MODE() === "assoc";
    btn.textContent = MODE() !== "public" ? hcfg.ctaPersonal : (isAssoc ? hcfg.ctaAssoc : hcfg.ctaClub);
    var seen = { hero: true, enq: false };
    var update = function () { btn.hidden = seen.hero || seen.enq || !!byId("kpcSent"); };
    if (stickyObs) stickyObs.disconnect();
    stickyObs = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { seen[en.target === enqSec ? "enq" : "hero"] = en.isIntersecting; });
      update();
    });
    stickyObs.observe(hero); stickyObs.observe(enqSec);
  }
  function renderTo() {
    /* keep the quiz's team question in step with "Talk to …" */
    each($$("#enq select[data-team]"), function (sel) { var a = askedAm(); sel.value = a ? a.id : ""; });
    var el = byId("toWho"); if (!el) return;
    var who = askedAm();
    el.textContent = who ? fill(TXT.toNamed, { manager: who.name }) : (TXT.toTeam || "");
  }

  /* Wiring for the parts that don't depend on the club: video, show-more buttons, FAQ,
     share and the form's submit. Re-run after the theme editor reloads a section. */
  function bind() {
    var box = byId("kpcVideo"), v = byId("shopvid"), b = byId("videoPlay");
    if (box && v && b) {
      /* Club shop walkthrough: poster until the play button is used, then the video takes over. */
      b.onclick = function () {
        box.classList.add("playing");
        v.controls = true;
        var p = v.play();
        if (p && p.catch) p.catch(function () { box.classList.remove("playing"); });
      };
      v.onended = function () { v.controls = false; v.load(); box.classList.remove("playing"); };
    }
    var mp = byId("moreProbs");
    if (mp) mp.onclick = function () {
      var s = $("#sorted .sorted"), sorted = CFG.sorted || {}; s.classList.toggle("open");
      this.innerHTML = s.classList.contains("open") ? esc(sorted.less) + "<span>&minus;</span>" : esc(sorted.more) + "<span>+</span>";
    };
    var mk = byId("moreKits");
    if (mk) mk.onclick = function () { var g = byId("kitGrid"), proof = CFG.proof || {}; g.hidden = !g.hidden; mk.textContent = g.hidden ? proof.more : proof.less; };
    /* opening one answer closes the last, so the list stays short */
    var faqs = $$("#faqList details");
    each(faqs, function (d) { d.ontoggle = function () { if (d.open) each(faqs, function (o) { if (o !== d) o.open = false; }); }; });
    /* "Send them this page": a personalised page shares its own personalised link */
    var share = byId("shareBtn");
    if (share) share.onclick = function () {
      var base = (CFG.rep || {}).partnerPageUrl || (location.origin + location.pathname);
      var u = MODE() !== "public" ? base + (base.indexOf("?") > -1 ? "&" : "?") + encodeLink(S) : base;
      var done = function () { toast("Link copied. Paste it to your committee."); };
      if (navigator.share) { navigator.share({ title: "KPI partner club", url: u }).catch(function () {}); }
      else if (navigator.clipboard) { navigator.clipboard.writeText(u).then(done, function () { toast("Copy the page address to share it."); }); }
      else toast("Copy the page address to share it.");
    };
    var formEl = byId("enqForm");
    /* Capture phase, so this runs before Shopify's own submit listener on the form. */
    if (formEl && !formEl.getAttribute("data-kpc-bound")) { formEl.addEventListener("submit", submit, true); formEl.setAttribute("data-kpc-bound", "1"); }
  }

  /* Submit: every answer is folded into contact[body] as "question: answer" lines, so
     the store's contact email (sales@kpisports.com.au, set as the store contact email
     in Shopify admin) reads as the whole enquiry. Writing it to Coach comes later.
     Posted through Shopify's own submit, so its spam check (hCaptcha) runs; the page
     reloads and the thank-you, kept in sessionStorage, names the person they asked for. */
  /* Thank-you: names the KPI person they chose ("Talk to ..." or the manager on their
     link); generic when nobody was chosen. */
  /* Thank-you cards (Build Spec stage 4b): the "What matters most" picks (`matters`, up to
     three, in the order picked) mapped to the page sections that answer them. One card per
     pick: their pick, that section's heading and opening line, and a link down to it.
     Picks with no section (balls & equipment, price), or no picks: the plain thank-you. */
  var MATTER_SECTIONS = {
    "club shop": ["how", "wins"], "less admin": ["sorted", "how"], "club revenue": ["wins", "sorted"],
    "design": ["sorted", "proof"], "service": ["team", "proof"], "women's & girls' fits": ["wins"]
  };
  function sentCards() {
    var box = byId("matters"); if (!box) return "";
    var picks = Array.prototype.slice.call(box.querySelectorAll('[aria-pressed="true"]'))
      .sort(function (a, b) { return Number(a.getAttribute("data-at") || 0) - Number(b.getAttribute("data-at") || 0); });
    var used = [], cards = [];
    picks.forEach(function (b) {
      var label = b.textContent.trim(), ids = MATTER_SECTIONS[label.toLowerCase().replace(/[\u2018\u2019]/g, "'")] || [];
      var id = ids.filter(function (x) { return used.indexOf(x) < 0 && byId(x) && !byId(x).hidden; })[0];
      if (!id) return;
      used.push(id);
      var sec = byId(id), h = sec.querySelector(".head h2"), intro = sec.querySelector(".head .intro p, .head > p");
      var line = intro ? intro.textContent.trim() : "";
      if (line.length > 150) line = line.slice(0, 147).replace(/\s+\S*$/, "") + "…";
      cards.push('<a class="sent-card" href="#' + id + '"><small>' + esc(label) + "</small><b>" + esc(h ? h.textContent.trim() : label) + "</b>" + (line ? "<span>" + esc(line) + "</span>" : "") + "<i>Read more</i></a>");
    });
    return cards.length ? '<div class="sent-cards">' + cards.join("") + "</div>" : "";
  }
  /* The thank-you, built before the post (it reads the answers and the link) and kept in
     sessionStorage, because Shopify's spam check finishes the send with a page reload. */
  var SENT_KEY = "kpcSent";
  function sentHtml() {
    var cards = MODE() === "public" ? sentCards() : "";
    var am = askedAm();
    var personal = MODE() !== "public";
    var nameEl = byId("f-name");
    var who = personal ? S.club : ((nameEl && nameEl.value.trim()) || "").split(" ")[0];
    var next = personal ? (am ? TXT.sentNamedPersonal : TXT.sentTeamPersonal) : (am ? TXT.sentNamed : TXT.sentTeam);
    return "<b>" + esc(TXT.thanks || "Thanks") + (who ? ", " + esc(who) : "") + '.</b><p style="margin-top:6px">' +
      esc(TXT.sent || "") + " " + esc(fill(next, { manager: am ? am.name : "" })) + "</p>" + cards;
  }
  /* After the reload Shopify prints its own generic thank-you (#kpcSent); put ours in its place. */
  function restoreSent() {
    var box = byId("kpcSent"), html = null;
    try { html = sessionStorage.getItem(SENT_KEY); sessionStorage.removeItem(SENT_KEY); } catch (err) {}
    if (box && html) box.innerHTML = '<div class="sent">' + html + "</div>";
  }
  function submit(e) {
    /* Ours alone: Shopify's spam check (hCaptcha, bound once someone types in the form)
       listens for the same submit and posts the form itself. Both used to run, so a good
       enquiry was sent and then sent again with a spent token: "Invalid CAPTCHA token". */
    e.preventDefault();
    e.stopImmediatePropagation();
    var formEl = byId("enqForm");
    var email = byId("f-email"), name = byId("f-name");
    var bad = email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.value.trim()) ? email : (name && !name.value.trim() ? name : null);
    if (bad) {
      var step = bad.closest(".step"); if (step) showStep(Number(step.getAttribute("data-step")));
      bad.focus(); toast(bad === email ? "Add an email so we can reply" : "Add your name so we know who to reply to");
      return;
    }
    var am = askedAm(), sp = SPORTS[S.sport];
    var lines = [
      "Enquiry type: " + ({ public: "Public enquiry (found the page)", club: "Personalised club link", assoc: "Personalised association link" })[MODE()],
      "Page sport: " + (sp ? sp.name : "-")
    ];
    if (S.club) lines.push((S.type === "assoc" ? "Association" : "Club") + " (from link): " + S.club);
    if (S.am) lines.push("KPI manager on link: " + ((findAm(S.am) || {}).name || S.am));
    if (S.inc) lines.push("Current supplier (from link): " + supplierName(S.inc) + " (" + S.inc + ")");
    if (S.pri.length) lines.push("Priorities (from link): " + S.pri.map(function (c) { return PRIORITY_NAMES[c]; }).join(", "));
    if (PREF) lines.push("Asked to talk to: " + (am ? am.name : "No preference"));
    lines.push("Page: " + location.href, "");
    STEPS.forEach(function (st, i) {
      if (st.title) lines.push("— " + st.title + " —");
      each($$('#enq .step[data-step="' + i + '"] [data-q]'), function (el) {
        if (el.closest("label[hidden]")) return;   /* e.g. the "Other" supplier box when Other isn't chosen */
        var opt = el.tagName === "SELECT" && el.selectedOptions[0];
        var v = el.classList.contains("chips")
          ? Array.prototype.map.call(el.querySelectorAll('[aria-pressed="true"]'), function (b) { return b.textContent; }).join(", ")
          : (opt && el.value && opt.text !== el.value ? opt.text + " (" + el.value + ")" : (el.value || "").trim());
        lines.push(el.getAttribute("data-q") + ": " + (v || "-"));
      });
      lines.push("");
    });
    byId("enqBody").value = lines.join("\n");
    postToCoach(am);
    byId("enqClub").value = S.club || (byId("f-club") ? byId("f-club").value.trim() : "");
    byId("enqContact").value = am ? am.name : "No preference";

    /* One post, through Shopify. Once its spam check has bound, formEl.submit is Shopify's
       wrapper: it gets an hCaptcha token, then posts the form normally and the page reloads
       on ?contact_posted=true. Before then it is the browser's own submit. Never post it in
       the background first: a token is good for one post. */
    try { sessionStorage.setItem(SENT_KEY, sentHtml()); } catch (err) {}
    track("partner_quiz_complete");
    var send = byId("stepSend"); if (send) { send.disabled = true; send.textContent = TXT.sending || "Sending…"; }
    formEl.submit();
  }

  /* ---- Coach (#1066) ----
     Every enquiry also goes to Coach, KPI's CRM, as JSON, so it lands in a rep's queue
     instead of only an inbox. It is sent alongside the Shopify contact post, never
     instead of it: Shopify's email to sales@ stays the backstop, so a Coach outage
     loses nothing. Fire and forget: keepalive lets it finish if the page navigates (the
     contact form's fallback), text/plain keeps it a CORS "simple" request with no
     preflight, and no cookies go with it. Off in the theme editor, and off when the
     "Coach address" setting on "Partner: enquiry form" is blank.
     Sent: the page's own answer codes (the field ids) with each question and answer,
     the personalised link's details including Coach's reference (ref=), the tracking
     tags, and whether it is the rep's own preview. Coach only SUGGESTS club facts from
     the answers; a rep confirms each one. */
  function uuid() {
    if (window.crypto && crypto.randomUUID) return crypto.randomUUID();
    var b = new Uint8Array(16);
    (window.crypto || window.msCrypto).getRandomValues(b);
    b[6] = (b[6] & 15) | 64; b[8] = (b[8] & 63) | 128;
    var h = Array.prototype.map.call(b, function (x) { return (x + 256).toString(16).slice(1); }).join("");
    return h.slice(0, 8) + "-" + h.slice(8, 12) + "-" + h.slice(12, 16) + "-" + h.slice(16, 20) + "-" + h.slice(20);
  }
  function postToCoach(am) {
    var url = (TXT.coach || "").trim();
    if (!url || !window.fetch || (window.Shopify && window.Shopify.designMode)) return;
    var answers = [];
    STEPS.forEach(function (st, i) {
      each($$('#enq .step[data-step="' + i + '"] [data-q]'), function (el) {
        if (el.closest("label[hidden]") || !el.id) return;
        var opt = el.tagName === "SELECT" && el.selectedOptions[0];
        var value = el.classList.contains("chips")
          ? Array.prototype.map.call(el.querySelectorAll('[aria-pressed="true"]'), function (b) { return b.textContent; }).join(", ")
          : (el.value || "").trim();
        if (!value) return;
        var a = { code: el.id, question: el.getAttribute("data-q") || "", value: value.slice(0, 2000) };
        if (opt && opt.text !== el.value) a.label = opt.text.slice(0, 2000);
        answers.push(a);
      });
    });
    var q = new URLSearchParams(location.search), personal = MODE() !== "public";
    var hp = byId("enqWebsite");
    var body = {
      id: uuid(),
      preview: !!S.preview,
      audience: MODE(),
      page_sport: S.sport || null,
      asked: PREF ? (am ? am.id : "none") : null,
      link: personal || S.ref ? { club: S.club || null, sport: S.sport || null, am: S.am || null, type: S.type, inc: S.inc || null, pri: S.pri, ref: S.ref || null } : null,
      utm: { source: q.get("utm_source"), medium: q.get("utm_medium"), campaign: q.get("utm_campaign") },
      answers: answers.slice(0, 80),
      website: hp ? hp.value : ""
    };
    try {
      fetch(url, { method: "POST", keepalive: true, credentials: "omit", mode: "cors", headers: { "content-type": "text/plain" }, body: JSON.stringify(body) })
        .catch(function () {});
    } catch (_) {}
  }

  /* ---- Personalised links ----
     The rep link builder and Coach make links in the Build Spec's form (from 21 Oct 2026):
       /pages/partner-club?club=Baringa%20FC&sport=football&am=emma&inc=veto&pri=shop,admin&type=assoc&logo=https://cdn.shopify.com/…&utm_source=…
     inc = current supplier slug (snippets/pc-suppliers), pri = up to three priority codes,
     logo = a crest in KPI's own Shopify files (any other address is ignored, see safeLogo).
     Earlier links still work: #club=…&supplier=…&focus=… (19–21 Oct), #k=<base64url JSON>.
     Once read, the club's details are cleaned out of the address bar (tracking tags stay)
     and kept in sessionStorage, so a reload stays personalised. preview=1 marks the rep's
     own preview, which is never counted in the visit tracking. */
  var LOGO_BASE = "https://cdn.shopify.com/s/files/1/0413/1543/4647/uploads/";
  var HASH_KEYS = { club: "club", sport: "sport", am: "am", supplier: "inc", logo: "logo", focus: "pri", type: "type", preview: "preview" };
  var LINK_KEYS = { c: "club", s: "sport", a: "am", t: "type", l: "logo", i: "inc", p: "pri" };
  /* ref = Coach's reference for a link made from a club's record (#1066): passed back
     with the enquiry so Coach knows which club it came from. Read and cleaned from the
     address like the rest. */
  var LEGACY = ["club", "sport", "am", "type", "logo", "inc", "pri", "preview", "ref"];
  var wordy = function (s) { return encodeURIComponent(String(s).replace(/-/g, "--").replace(/ +/g, "-")); };
  var unwordy = function (s) { return s.replace(/--/g, "\u0000").replace(/-/g, " ").replace(/\u0000/g, "-"); };
  /* the link for "Send them this page": the same ?club=…&inc=… form the rep link builder
     and Coach make (buildPartnerPageUrl in Coach's src/modules/striker/lib/partner-page-link.ts) */
  function encodeLink(st) {
    var q = new URLSearchParams();
    q.set("club", st.club || "");
    if (st.sport) q.set("sport", st.sport);
    if (st.am) q.set("am", st.am);
    if (st.type === "assoc") q.set("type", "assoc");
    if (st.inc) q.set("inc", st.inc);
    if (st.pri && st.pri.length) q.set("pri", st.pri.join(","));
    if (st.logo) q.set("logo", st.logo);
    return q.toString().replace(/\+/g, "%20").replace(/%2C/gi, ",").replace(/%3A/gi, ":").replace(/%2F/gi, "/");
  }
  function readHash(h) {
    var d = {};
    h.replace(/^#/, "").split("&").forEach(function (pair) {
      var at = pair.indexOf("="); if (at < 1) return;
      var key = HASH_KEYS[pair.slice(0, at).toLowerCase()];
      var v = pair.slice(at + 1).split("?")[0];
      try { v = decodeURIComponent(v.replace(/\+/g, " ")); } catch (_) { return; }
      if (!key || !v) return;
      if (key === "club") v = unwordy(v);
      if (key === "logo") v = /^[A-Za-z0-9._-]+$/.test(v) && v.indexOf("..") < 0 ? LOGO_BASE + v : "";
      if (v) d[key] = v;
    });
    return d;
  }
  function decodeLink(tok) {
    try {
      var j = JSON.parse(decodeURIComponent(escape(atob(tok.replace(/-/g, "+").replace(/_/g, "/"))))), d = {};
      Object.keys(LINK_KEYS).forEach(function (k) { if (j[k] != null) d[LINK_KEYS[k]] = Array.isArray(j[k]) ? j[k].join(",") : String(j[k]); });
      return d;
    } catch (_) { return {}; }
  }
  function readLink() {
    var d = {}, h = location.hash, q = new URLSearchParams(location.search);
    var tok = h.match(/[#&]k=([A-Za-z0-9_-]+)/), plain = /[#&]club=/i.test(h);
    var legacy = LEGACY.some(function (k) { return q.has(k); });
    if (tok) d = decodeLink(tok[1]);
    else if (plain) d = readHash(h);
    else LEGACY.forEach(function (k) { if (q.get(k)) d[k] = q.get(k); });
    if (tok || plain || legacy) {
      d.fresh = true;   /* opened from the link itself, not a reload */
      try { sessionStorage.setItem("kpc-link", JSON.stringify({ path: location.pathname, d: d })); } catch (_) {}
      LEGACY.forEach(function (k) { q.delete(k); });
      var qs = q.toString();
      history.replaceState(history.state, "", location.pathname + (qs ? "?" + qs : ""));
    } else {
      /* a reload (or back/forward) of a personalised page stays personalised; a fresh visit doesn't */
      var nav = window.performance && performance.getEntriesByType ? performance.getEntriesByType("navigation")[0] : null;
      try {
        var saved = JSON.parse(sessionStorage.getItem("kpc-link") || "null");
        if (saved && saved.path === location.pathname && nav && (nav.type === "reload" || nav.type === "back_forward")) { d = saved.d || {}; delete d.fresh; }
        else if (saved && saved.path === location.pathname) sessionStorage.removeItem("kpc-link");
      } catch (_) {}
    }
    return d;
  }

  /* ---- Visit tracking (Rep Links and Tracking Brief, part 3) ----
     Personalised pages only; the public page sends nothing extra. Three events, each with
     the club's name and its KPI manager code (never a person's name, email or phone):
       partner_page_view      the club's link is opened (not on a reload): + sport, source
       partner_quiz_start     the first tick, typed answer or Next in the enquiry
       partner_quiz_complete  the enquiry is sent
     Sent to Google Analytics only (the GA4 ID in "Partner: hero", not Google Ads or Meta)
     and to Shopify's customer events (Shopify.analytics.publish) for a custom pixel.
     Never sent from the rep's own preview (#…&preview=1) or the theme editor. */
  var TRACK = { on: false, view: false, started: false };
  function track(name, extra) {
    if (!TRACK.on) return;
    var p = Object.assign({ club: S.club, am: S.am || "none" }, extra || {});
    var id = (CFG.hero || {}).gaId;
    try { if (window.gtag && id) window.gtag("event", name, Object.assign({ send_to: id }, p)); } catch (_) {}
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(name, p); } catch (_) {}
  }
  var quizStart = function (e) {
    if (TRACK.started) return;
    var t = e.target;
    if (e.type === "click" && !(t.closest && t.closest(".chip, #stepNext"))) return;
    TRACK.started = true;
    track("partner_quiz_start");
  };

  function boot() {
    load();
    if (!SPORTS[S.sport]) S.sport = SPORT_KEYS[0] || "";
    if (S.am && !findAm(S.am)) S.am = "";
    render();
    bind();
    applyOrder();
    sticky();
    var enq = byId("enq");
    if (enq && !enq.hasAttribute("data-kpc-track")) {
      enq.setAttribute("data-kpc-track", "");
      ["input", "change", "click"].forEach(function (ev) { enq.addEventListener(ev, quizStart, true); });
    }
  }

  load();
  var p = readLink();
  if (p.club) S.club = p.club.slice(0, 120);
  if (findAm(p.am)) S.am = p.am;
  if (SPORTS[p.sport]) S.sport = p.sport;
  if (p.type === "assoc") S.type = "assoc";
  S.logo = safeLogo(p.logo);
  /* inc = the club's current supplier, pri = up to three priorities, both from the rep
     builder and read client-side only. Absent or unknown values are ignored and the page
     renders as standard. */
  if (supplierName(p.inc)) S.inc = p.inc;
  S.preview = p.preview === "1";
  S.ref = /^[A-Za-z0-9]{8,32}$/.test(p.ref || "") ? p.ref : "";
  S.pri = (p.pri || "").split(",").filter(function (c, i, a) { return PRIORITIES[c] && a.indexOf(c) === i; }).slice(0, 3);
  boot();
  /* visit tracking: on for a club's own link, off for the public page, the rep's preview and the theme editor */
  TRACK.on = MODE() !== "public" && p.preview !== "1" && !(window.Shopify && window.Shopify.designMode);
  if (TRACK.on && p.fresh) track("partner_page_view", { sport: S.sport, source: (new URLSearchParams(location.search).get("utm_source") || "direct").slice(0, 60) });
  /* after a send, Shopify reloads the page; show our thank-you and bring it into view */
  if (byId("kpcSent")) restoreSent();
  if (byId("kpcSent") && byId("enquire")) byId("enquire").scrollIntoView({ block: "start" });

  /* Theme editor: a changed section is re-rendered in place, so rebuild from the new
     settings; picking a block shows it (its sport, a hidden problem row, an FAQ answer). */
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener("shopify:section:load", function () { boot(); });
    document.addEventListener("shopify:section:unload", function () { setTimeout(boot, 0); });
    document.addEventListener("shopify:block:select", function (e) {
      var t = e.target;
      if (t.matches && t.matches("[data-sport]")) t.click();
      if (t.matches && t.matches(".srow.extra")) { var s = t.closest(".sorted"); if (s && !s.classList.contains("open") && byId("moreProbs")) byId("moreProbs").click(); }
      if (t.tagName === "DETAILS") t.open = true;
    });
  }
})();
